import React from 'react';
import { useTranslation } from 'react-i18next';
import { Image, StyleProp, StyleSheet, Text, View, ViewStyle } from 'react-native';

import { VipTicketPng } from '../../../assets/bonuses';
import { useVipTicketBalance } from '../../../utils/hooks/useVipTicketBalance';
import { groupThousands } from '../Event/eventTheme';
import { BONUS_FONT, bonusColors } from './bonusesTheme';

type Props = {
	/** The row's height: the info button's, so the two sit on one line. */
	size: number;
	style?: StyleProp<ViewStyle>;
};

/**
 * "{ticket}:{amount}" - the player's VIP Ticket balance beside the VIP Arcade info button. Hidden
 * until the wallet answers (and when logged out), so it never flashes a 0 it does not know.
 */
export const VipTicketBalance = ({ size, style }: Props) => {
	const { t } = useTranslation();
	const balance = useVipTicketBalance();
	if (balance == null) return null;

	const fontSize = size * 0.53;
	return (
		<View
			pointerEvents='none'
			accessible
			accessibilityLabel={t('T_SITE_VIP_TICKETS_BALANCE', {
				defaultValue: 'VIP Tickets: {{amount}}',
				amount: balance,
			})}
			style={[styles.row, { height: size }, style]}
		>
			<Image source={VipTicketPng} style={{ width: size, height: size }} resizeMode='contain' />
			<Text numberOfLines={1} style={[styles.amount, { fontSize, lineHeight: fontSize * 1.2 }]}>
				:{groupThousands(balance)}
			</Text>
		</View>
	);
};

const styles = StyleSheet.create({
	row: {
		flexDirection: 'row',
		alignItems: 'center',
	},
	// The VIP ARCADE title's type: Sofia Sans Bold in text/accent.
	amount: {
		color: bonusColors.accent,
		fontFamily: BONUS_FONT,
		fontWeight: '700',
	},
});

export default VipTicketBalance;
